
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import  themen  from 'theme/styles/styled-colors';
import  * as theme  from 'react-syntax-highlighter/dist/esm/styles/hljs';
import SyntaxHighlighter from 'react-syntax-highlighter';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "export--import-rest-apis"
    }}>{`Export & Import REST APIs`}</h1>
    <h3 {...{
      "id": "whats-new"
    }}>{`What's New`}</h3>
    <p>{`The release of 0.8.3 includes the following improvements to Export and Import APIs:`}</p>
    <ul>
      <li parentName="ul">{`Export: Support for `}<a parentName="li" {...{
          "href": "#/IncrementalExport"
        }}>{`Incremental Export`}</a>{`.`}</li>
      <li parentName="ul">{`Export & Import: Support for `}<a parentName="li" {...{
          "href": "#/ReplicatedAttributes"
        }}>{`replicated attributes`}</a>{` to entities made possible by `}<a parentName="li" {...{
          "href": "#/SoftReference"
        }}>{`SoftReference`}</a>{` entity attribute option.`}</li>
      <li parentName="ul">{`Export option: `}<a parentName="li" {...{
          "href": "#/IncrementalExport"
        }}>{`skipLineage`}</a>{`.`}</li>
      <li parentName="ul">{`New entity transforms framework.`}</li>
      <li parentName="ul">{`New `}<a parentName="li" {...{
          "href": "#/AtlasServer"
        }}>{`AtlasServer`}</a>{` entity type.`}</li>
      <li parentName="ul">{`Export: `}<a parentName="li" {...{
          "href": "#/ExportHDFSAPI"
        }}>{`Automatic creation of HDFS path`}</a>{` requested entities.`}</li>
      <li parentName="ul">{`New `}<a parentName="li" {...{
          "href": "#/ExportImportAudits"
        }}>{`ExportImportAudits`}</a>{` for Export & Import operations.`}</li>
    </ul>
    <h3 {...{
      "id": "background"
    }}>{`Background`}</h3>
    <p>{`The Import-Export APIs for Atlas facilitate the transfer of data to and from a cluster that has Atlas provisioned.`}</p>
    <p>{`The APIs when integrated with backup and/or disaster recovery process will ensure participation of Atlas.`}</p>
    <h3 {...{
      "id": "introduction"
    }}>{`Introduction`}</h3>
    <p>{`There are 2 broad categories viz. Export & Import. The details of the APIs are as discussed below.`}</p>
    <p>{`The APIs are available only to `}<em parentName="p">{`admin`}</em>{` user.`}</p>
    <p>{`Only a single import or export operation can be performed at a given time. The operations have the potential for generating large amount of data. They can also put pressure on resources. This restriction tries to alleviate this problem.`}</p>
    <p>{`For Import-Export APIs relating to HDFS path, can be found `}<a parentName="p" {...{
        "href": "#/ExportHDFSAPI"
      }}>{`here`}</a>{`.`}</p>
    <p>{`For additional information please refer to the following:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://issues.apache.org/jira/browse/ATLAS-1503"
        }}>{`ATLAS-1503`}</a>{` Original Import-Export API requirements.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://issues.apache.org/jira/browse/ATLAS-1618"
        }}>{`ATLAS-1618`}</a>{` Export API Scope Specification.`}</li>
    </ul>
    <h3 {...{
      "id": "errors"
    }}>{`Errors`}</h3>
    <p>{`If an import or export operation is initiated while another is in progress, the consumer will receive this error:`}</p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`"ATLAS5005E": "Another import or export is in progress. Please try again."`}
    </SyntaxHighlighter>
    <p>{`Unhandled errors will be returned as Internal error code 500.`}</p>
    <h3 {...{
      "id": "rest-api-reference"
    }}>{`REST API Reference`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#/ExportAPI"
        }}>{`Export`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#/ExportHDFSAPI"
        }}>{`Export HDFS`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#/ImportAPI"
        }}>{`Import`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#/ImportAPIOptions"
        }}>{`Import Options`}</a></li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;